import { gql } from '@apollo/client/core';

/**
 * Selections for the staff deliverability report. Keep these in step with `EmailDelivery.ts` and
 * `EmailDeliverySummary.ts` — every field selected here is mapped there, and nothing more is
 * selected than is mapped.
 *
 * Both fragments cover their type completely: every field the schema exposes on `EmailDelivery` is a
 * column the report shows, and the summary envelope is only a key, four measures and a total. So
 * there is no deliberate omission to document here — the one unselected field is the *connection's*
 * `nodes`, and `EmailDelivery.fromGqlConnection` says why it derives those from the edges instead.
 */
export const INTERNAL_EMAIL_DELIVERY_FIELDS = gql`
  fragment InternalEmailDeliveryFields on EmailDelivery {
    id
    to
    subject
    state
    createdAt
    sentAt
    deliveredAt
    mailStream
    recipientDomain
    terminalEventType
    terminalEventReason
    account {
      id
      name
    }
  }
`;

export const INTERNAL_EMAIL_DELIVERY_SUMMARY_FIELDS = gql`
  fragment InternalEmailDeliverySummaryFields on EmailDeliverySummary {
    total
    groups {
      key
      measures {
        sent
        delivered
        failed
        failureRate
      }
    }
  }
`;
